module.exports = __webpack_public_path__ + "img/hair_back_female_frizzy_short.836a3414.png";